// Background personalization themes. Image themes reference files in
// /public; color themes carry a swatch (for the picker tile) and a wash
// (the full-bleed gradient painted behind the app).

export type BgTheme =
  | { label: string; type: "img"; img: string }
  | { label: string; type: "color"; swatch: string; wash: string }
  | { label: string; type: "none" };

export const BG_THEMES: BgTheme[] = [
  { label: "Scene", type: "img", img: "/background/footer-scene.webp" },
  { label: "Bench", type: "img", img: "/background/bench-scene.webp" },
  { label: "Coastal", type: "img", img: "/background/coastal-scene.webp" },
  { label: "Forest", type: "img", img: "/background/forest-scene.webp" },
  {
    label: "Blush",
    type: "color",
    swatch: "linear-gradient(150deg,#f6ded9 0%,#ecc4bf 100%)",
    wash: "linear-gradient(to top,#ecc4bf 0%,#f7e6e2 62%,rgba(254,252,253,0) 100%)",
  },
  {
    label: "Sage",
    type: "color",
    swatch: "linear-gradient(150deg,#e5efdf 0%,#c6d6be 100%)",
    wash: "linear-gradient(to top,#c6d6be 0%,#e5efdf 62%,rgba(254,252,253,0) 100%)",
  },
  {
    label: "Sky",
    type: "color",
    swatch: "linear-gradient(150deg,#e3e7f4 0%,#c6cfe9 100%)",
    wash: "linear-gradient(to top,#c6cfe9 0%,#e3e7f4 62%,rgba(254,252,253,0) 100%)",
  },
  { label: "None", type: "none" },
];
